export default [
  {
    path: '/apps/tipo-tabela/list',
    name: 'apps-tipo-tabela-list',
    component: () => import('@/views/cadastros/apoio-vendas/tipo-tabela/list/Index.vue'),
    meta: {
      pageTitle: 'Tipo Tabela',
    },
  },
  // {
  //     path: '/apps/tipo-tabela/edit/:id',
  //     name: 'apps-tipo-tabela-edit',
  //     component: () => import('@/views/cadastros/tipo-tabela/tipo-tabela-edit/TipoTabelaEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Canal de Venda',
  //     },
  // },
];
